import { render, staticRenderFns } from "./rep_orders_dash.vue?vue&type=template&id=253e105f&scoped=true&"
import script from "./rep_orders_dash.vue?vue&type=script&lang=js&"
export * from "./rep_orders_dash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253e105f",
  null
  
)

export default component.exports